import { LocationData } from '~admin/model/location-data';
import { LocationProfileResponse } from '~client/model/location-profile-response';

export const mapLocationData = (response: LocationProfileResponse): LocationData => {
  const { id, locationName } = response;

  return {
    id,
    locationName,
  };
};

export const mapLocationDataList = (response: LocationProfileResponse[]): LocationData[] =>
  response.map(mapLocationData);



// WEBPACK FOOTER //
// ./model/location-data.mapper.ts